 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTTOC from '@/components/Text/toc'
 import TEXTDIA from '@/components/Text/dia'
 import TEXTPREFACE from '@/components/Text/preface'
 import TEXTACK from '@/components/Text/ack'
 import TEXTPT1 from '@/components/Text/pt1'
 import TEXTCH1 from '@/components/Text/ch1'
 import TEXTCH2 from '@/components/Text/ch2'
 import TEXTCH3 from '@/components/Text/ch3'
 import TEXTCH4 from '@/components/Text/ch4'
 import TEXTPT2 from '@/components/Text/pt2'
 import TEXTCH5 from '@/components/Text/ch5'
 import TEXTCH6 from '@/components/Text/ch6'
 import TEXTCH7 from '@/components/Text/ch7'
 import TEXTCH8 from '@/components/Text/ch8'
 import TEXTCH9 from '@/components/Text/ch9'
 import TEXTCH10 from '@/components/Text/ch10'
 import TEXTCH11 from '@/components/Text/ch11'
 import TEXTCH12 from '@/components/Text/ch12'
 import TEXTCH13 from '@/components/Text/ch13'
 import TEXTPT3 from '@/components/Text/pt3'
 import TEXTCH14 from '@/components/Text/ch14'
 import TEXTCH15 from '@/components/Text/ch15'
 import TEXTCH16 from '@/components/Text/ch16'
 import TEXTCH17 from '@/components/Text/ch17'
 import TEXTADD from '@/components/Text/add'
 import TEXTSTUDYGUIDE from '@/components/Text/studyguide'
 import TEXTSG1 from '@/components/Text/sg1'
 import TEXTSG2 from '@/components/Text/sg2'
 import TEXTSG3 from '@/components/Text/sg3'
 import TEXTSG4 from '@/components/Text/sg4'
 import TEXTSG5 from '@/components/Text/sg5'
 import TEXTSG6 from '@/components/Text/sg6'
 import TEXTSG7 from '@/components/Text/sg7'
 import TEXTSG8 from '@/components/Text/sg8'
 import TEXTSG9 from '@/components/Text/sg9'
 import TEXTSG10 from '@/components/Text/sg10'
 import TEXTSG11 from '@/components/Text/sg11'
 import TEXTSG12 from '@/components/Text/sg12'
 import TEXTSG13 from '@/components/Text/sg13'
 import TEXTSG14 from '@/components/Text/sg14'
 import TEXTSG15 from '@/components/Text/sg15'
 import TEXTSG16 from '@/components/Text/sg16'
 import TEXTSG17 from '@/components/Text/sg17'
 import TEXTGLOSS from '@/components/Text/gloss'
 import TEXTNOTES from '@/components/Text/notes'
 import TEXTDEDI from '@/components/Text/dedi'
 import TEXTPRAISE from '@/components/Text/praise'
 import TEXTATA from '@/components/Text/ata'
 import TEXTMOREIVP from '@/components/Text/moreivp'
 import TEXTRIGHTS from '@/components/Text/rights'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/toc",
 			"name" : "Text/toc",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/dia",
 			"name" : "Text/dia",
 			"component" : TEXTDIA
 		},
 		{
 			"path" : "/Text/preface",
 			"name" : "Text/preface",
 			"component" : TEXTPREFACE
 		},
 		{
 			"path" : "/Text/ack",
 			"name" : "Text/ack",
 			"component" : TEXTACK
 		},
 		{
 			"path" : "/Text/pt1",
 			"name" : "Text/pt1",
 			"component" : TEXTPT1
 		},
 		{
 			"path" : "/Text/ch1",
 			"name" : "Text/ch1",
 			"component" : TEXTCH1
 		},
 		{
 			"path" : "/Text/ch2",
 			"name" : "Text/ch2",
 			"component" : TEXTCH2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js